export function inview(bp, $) {
    $('.inView--left01, .inView--left02, .inView--left03').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).addClass('inView');
        }
    });
}
